import {
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';
import InfoTooltip from '../InfoTooltip';
import { FaArrowLeftLong } from 'react-icons/fa6';
import imageCompression from 'browser-image-compression';
import { SlCloudUpload } from 'react-icons/sl';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';
import {
  createCategory,
  createDoorList,
  createSpecialAccesss,
  getBnbList,
  updateSpecialAccess,
  uploadFile,
  updateCity,
} from '../../helper/backend_helper';
import appConfig from '../../config';

const UpdateCity = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userData = location?.state?.userData;
  const [formData, setFormData] = useState({ profileImage: null });
  const [name, setName] = useState(userData?.name);
  // const [bnb, setBnB] = useState(userData?.bnb);
  const [description, setDescription] = useState(userData?.description);
  const [italiandescription, setitaliandescription] = useState(userData?.italiandescription);
  const [loading, setLoading] = useState(false);
  const handleFileChange = (e) => {
    const { name, files } = e.target;

    setFormData({
      ...formData,
      [name]: files[0],
    });
  };

  const [users, setUsers] = useState([]);
  console.log('users', users);
  async function fetchData() {
    try {
      const usersResponse = await getBnbList();
      setUsers(usersResponse?.data?.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  const handleSave = async () => {
    try {
      setLoading(true);

      if (!name) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Name is required',
        });
        setLoading(false);
        return;
      }
      if (!description) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Description is required',
        });
        setLoading(false);
        return;
      }

      if (!italiandescription) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Italian Description is required',
        });
        setLoading(false);
        return;
      }
      if (!formData.profileImage) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Image is required',
        });
        setLoading(false);
        return;
      }

      const headers = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };
      let imageUploadResponse;
      if (formData.profileImage) {
        const originalFile = formData.profileImage;

        // Log original file size
        console.log('Original file size:', (originalFile.size / 1024).toFixed(2), 'KB');

        // Compression options
        const options = {
          maxSizeMB: 0.3, // Compress to a maximum of 0.5 MB
          maxWidthOrHeight: 800, // Restrict dimensions to 800px
          useWebWorker: true, // Use web worker for performance
          initialQuality: 0.6, // Reduce starting quality to 60%
        };

        // Compress image
        const compressedFile = await imageCompression(originalFile, options);

        // Log compressed file size
        console.log('Compressed file size:', (compressedFile.size / 1024).toFixed(2), 'KB');
        const data = new FormData();
        data.append('file', compressedFile);

        imageUploadResponse = await uploadFile(data, headers);

        if (imageUploadResponse.status !== 200) {
          throw new Error('Image upload failed');
        }
      }
      const Categorydata = {
        name,
        image: imageUploadResponse?.data?.data?.fileName || userData?.image,
        description,
        italiandescription,
      };

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await updateCity(userData?._id, Categorydata, Categoryheaders);

      Swal.fire({
        icon: 'success',
        title: 'City updated successfully',
      });

      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${error?.response?.data?.errors[0]?.message}`,
      });
    }
  };

  return (
    <>
      <Helmet>
        <title> Update City </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <FaArrowLeftLong size={24} />
          <Typography variant="h4">Update City</Typography>
        </Stack>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: { xs: '100%', sm: '50ch' } }, // Responsive
          }}
          noValidate
          autoComplete="off"
        >
          <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Name <InfoTooltip title="City name as shown to guests in the app and on the city's around-us page." /></FormLabel>
              <TextField
                label="Enter Name"
                id="outlined-size-small"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Stack>
          </Stack>
          <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mt: 2, mb: 1 }}>Description <InfoTooltip title="English description of the city shown to guests in the app." /></FormLabel>
              <TextField
                label="Enter Description"
                id="outlined-multiline"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                multiline
                minRows={5}
                variant="outlined"
              />
            </Stack>
          </Stack>
          <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mt: 2, mb: 1 }}>Italian Description <InfoTooltip title="Italian-language version of the city description, shown to guests using the app in Italian." /></FormLabel>
              <TextField
                label="Enter Italian Description"
                id="outlined-multiline"
                value={italiandescription}
                onChange={(e) => setitaliandescription(e.target.value)}
                multiline
                minRows={5}
                variant="outlined"
              />
            </Stack>
          </Stack>
          <Stack
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              gap: 2,
              marginTop: 2,
            }}
          >
            <Stack>
              {!formData.profileImage ? (
                <img
                  src={`${appConfig.FILE_URL}${userData?.image}`}
                  alt="img"
                  style={{ maxWidth: '250px', borderRadius: 20, padding: 5 }}
                />
              ) : (
                <img
                  src={URL.createObjectURL(formData.profileImage)}
                  alt="img"
                  style={{ maxWidth: '250px', borderRadius: 20, backgroundColor: '#1E3A5F', padding: 5 }}
                />
              )}
            </Stack>
            <Button
              sx={{
                width: 170,
                color: '#1E3A5F',
                borderColor: '#1E3A5F',
                '&:hover': {
                  borderColor: '#1E3A5F',
                  boxShadow: 'none',
                },
              }}
              component="label"
              variant="outlined"
              size="medium"
              startIcon={<SlCloudUpload />}
            >
              upload Image
              <input
                type="file"
                accept="image/*"
                name="profileImage"
                style={{ display: 'none' }}
                onChange={handleFileChange}
              />
            </Button>
          </Stack>
          {/* <Stack spacing={{ xs: 2, sm: 4 }} mt={2} direction="row" useFlexGap flexWrap="wrap">
            <FormControl sx={{ width: 490 }}>
              <FormLabel sx={{ mb: 1 }}>BnB</FormLabel>
              <Select
                labelId="demo-multi-select-label"
                id="demo-multi-select"
                multiple
                value={bnb} // This will be an array
                onChange={(e) => setBnB(e.target.value)}
                renderValue={(selected) => selected.join(', ')} // Render selected values as a comma-separated string
              >
                {users?.map((user) => (
                  <MenuItem key={user._id} value={user.BnBShortName}>
                    <Checkbox checked={bnb.indexOf(user.BnBShortName) > -1} />
                    {user.BnBShortName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack> */}
        </Box>
        <LoadingButton
          sx={{
            width: 100,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Update
        </LoadingButton>
      </Card>
    </>
  );
};

export default UpdateCity;
